import type { ResponsePayloadWithData } from '.';
import api from '.';
import type { ContentTypeSummary } from './exercise-category';

export interface ExerciseNodeWithoutDescription {
  id: string;
  name: string;
  exerciseCount: number;
  completedExerciseCount?: number;
  score?: {
    maximum: number;
    achievable: number;
    achieved: number;
  };
  contentTypeSummary?: ContentTypeSummary[];
  nodes: ExerciseNodeWithoutDescription[];
}

export interface ExerciseNode extends ExerciseNodeWithoutDescription {
  description: string;
  nodes: ExerciseNode[];
}

export async function getExerciseNodes(moduleId: string) {
  const { data } = await api.get<ResponsePayloadWithData<ExerciseNodeWithoutDescription[]>>(
    `/studio/modules/${moduleId}/exercise-nodes/usage`,
  );

  return data;
}
